/** Base filter parameters. */
export namespace BaseFilterParams {

  /** Search filter. */
  export type Search = {

    /** Search filter. */
    readonly search: string;
  };

  /** Pagination filters. */
  export type Pagination = {

    /** Page number filter. */
    readonly pageNumber: number;

    /** Page size filter. */
    readonly pageSize: number;
  };

  /** Search and pagination filters. */
  export type Combined = Search & Pagination;
}

/** Default pagination options. */
export const DEFAULT_PAGINATION_OPTIONS: BaseFilterParams.Pagination = {
  pageNumber: 0,
  pageSize: 5,
};
